import { lazy } from 'react';
const rebondin = lazy(() => import('./rebondin'));

const rebondinRoutes = [
  {
    path: '/rebondin',
    component: rebondin
  }
];
export default rebondinRoutes;
